import { render, staticRenderFns } from "./ProductFrom.vue?vue&type=template&id=03d4b02c&scoped=true&"
import script from "./ProductFrom.vue?vue&type=script&lang=js&"
export * from "./ProductFrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d4b02c",
  null
  
)

export default component.exports